import React, { useState } from "react";
import { logo, smallLogo, swiper1, swiper2 } from "../assets/images";
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai";
import { Slide } from "react-awesome-reveal";

const Register = () => {
  const [swiper, setSwiper] = useState<boolean>(false);

  const Swiper1 = () => (
    <Slide direction="left" duration={1000}>
      <div className=" lg:mt-20 h-full mt-16 px-2 lg:px-8 mx-auto ease-in duration-1000 flex gap-5 justify-center items-center flex-col text-white">
        <div>
          <img
            src={swiper1}
            alt=""
            className="w-[284px] h-[200px] lg:h-[319px]"
          />
        </div>
        <h2 className="font-sora font-bold text-2xl">Trade Giftcards</h2>
        <h4 className="font-manrope text-center font-medium text-[16px]">
          Trading with us is completely safe and secure. Your gift cards &
          bitcoins are safe because we redeem them directly. We don't give out
          cards to third party.
        </h4>
      </div>
    </Slide>
  );
  const Swiper2 = () => (
    <Slide direction="left" duration={1000}>
      <div className=" lg:mt-20 mt-4 ease-in h-full duration-1000 px-2 lg:px-6 mx-auto flex gap-5 justify-center items-center flex-col text-white">
        <div>
          <img src={swiper2} alt="" />
        </div>
        <h2 className="font-sora font-bold text-2xl">Trade Crypto</h2>
        <h4 className="font-manrope text-center font-medium text-[16px]">
          Trading with us is completely safe and secure. Your gift cards &
          bitcoins are safe because we redeem them directly. We don't give out
          cards to third party.
        </h4>
      </div>
    </Slide>
  );

  return (
    <div className="hidden lgss:flex flex-col h-full font-manrope justify-around items-start w-[45%] px-[45px] pt-[20px]  bg-hero bg-cover text-white">
      <div>
        <img src={logo} className="w-[110px] h-[29px]" alt="logo" />
      </div>
      <div className="w-full h-5/6 flex flex-col items-center justify-center">
        <div>{swiper ? <Swiper1 /> : <Swiper2 />}</div>
        <div className="h-[0.4px] mt-6 w-11/12 bg-white mx-auto" />
        <div className="flex gap-3 justify-center mt-4 items-center">
          <AiFillLeftCircle
            className="text-3xl cursor-pointer"
            onClick={() => setSwiper((prev) => !prev)}
          />
          <div
            className={
              swiper
                ? "w-[10px] h-[10px] rounded-full border border-white"
                : "w-[10px] h-[10px] rounded-full bg-white"
            }
          />
          <div
            className={
              swiper
                ? "w-[10px] h-[10px] rounded-full bg-white"
                : "w-[10px] h-[10px] rounded-full border border-white"
            }
          />
          <AiFillRightCircle
            className="text-3xl cursor-pointer"
            onClick={() => setSwiper((prev) => !prev)}
          />
        </div>
      </div>
    </div>
  );
};

export default Register;
